import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams, useOutletContext } from "react-router-dom";
import { useAlert } from "react-alert";

import Audience from "../components/Audience";

// Api Calls



function AudienceCreatePage(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [missionType, loadingMissionType, nextPage, backPage] = [props.missionType, props.loadingMissionType, props.nextPage, props.backPage]


    return (
        <Audience
            nextPath={nextPage}
            backPath={backPage}
            missionType={missionType}
            nextText="Next"
        />
    )

}

export default AudienceCreatePage;